import { interfaceDescription } from "@/views/loyalty/models/justpay-configuration-interface.model"
import { planogrammExt } from "@/views/loyalty/models/justpay-configuration-planogramm.model"

const condition = {
    type: 0,
    conditions: [],
    value: 0,
    number: 0
}

const command = {
    number: 0,
    type: 0,
    value: 0,
    time: 0,
    timeout: 0
}

const action = {
    condition: condition,
    command: command,
    error_timeout: 0,
    before_timeout: 0,
    after_timeout: 0,
    error_action: 0,
    command_type: 0
}

const rele = {
    actions: [{ ...action }],
    screen: 0,
    timeout_action: 0,
    timeout: 0
}

const releSettings = {
    ip: '',
    port: 0,
    password: ''
}

const releConfiguration = {
    pages: [{ ...rele }],
    settings: releSettings,
}

const releScenario = {
    scenarioId: '',
    scenarioName: '',
    releConf: releConfiguration
}

export const configuration = {
    interface_description: interfaceDescription,
    planogramm: [{ ...planogrammExt }],
    rele: releConfiguration,
    type: 0,
    releScenarios: [{ ...releScenario }],
}

export const ActionCommandEnum = Object.freeze({ NoCommand: 0, RequestRelay: 1, ShowMainScreen: 2 })
export const ActionConditionEnum = Object.freeze({ NoCommand: 0, Or: 1, And: 2, RelayValue: 3, SensorValue: 4 })
export const ConfigurationTypeEnum = Object.freeze({ Vending: 0, Point: 1, Payment: 2, Delivery: 3, Donation: 4, Automoika: 5, Vitrina: 6, Azs: 7, PosPoint: 8, Rele: 9, PosPointRelay: 10, YandexCarWash: 11 })
export const ConfigurationDescriptionTypeEnum = Object.freeze({ Sum: 1, Quantity: 2, Overview: 3 })
export const ConfigurationPosTypeEnum = Object.freeze({ DataInput: 0, Information: 1, Catalog: 2, Cart: 3 })
export const ConfigurationFirstScreenTypeArray = [{ text: 'Стандартный режим', value: 1 }, { text: 'Выбор способа оплаты', value: 2 }, { text: 'Универсальный экран - Банковская карта + QR', value: 3 }, { text: 'Чтение карты доступа режим', value: 4 }, { text: 'Чтение карты доступа + Оплата', value: 5 }]
export const ConfigurationPaymentMethodScreenTypeArray = [{ text: 'Выбор способа оплаты', value: 2 }, { text: 'Универсальный экран - Банковская карта + QR', value: 3 }, { text: 'Чтение карты доступа режим', value: 4 }, { text: 'Чтение карты доступа + Оплата', value: 5 }]
